import {
    getToken,
    getJWT,
    getOperator,
    getGroup,
    getUserType
} from '@/common/oauth'
import {
    Message
} from 'element-ui'
import axios from 'axios'
import store from "./../vuex/store"
import {
    getExpireIn
} from "./oauth";
// 一些请求的全局配置,具体见文档http://www.axios-js.com/zh-cn/docs/index.html#axios-get-url-config
// 表示跨域请求时是否需要使用凭证
axios.defaults.withCredentials = false
    //如果请求超过timeout时间则会被中断
axios.defaults.timeout = 60000
axios.defaults.headers.post['Content-Type'] = 'application/json'

/**
 * 添加请求头：
 * 'Authorization':Bearer jwt令牌 sessionUtil.getSession(sysConfig.sessionStorageKeys.jwtToken)
 * 'Token': user_token cookieUtil.getCookie(sysConfig.cookieKeys.tokenKey)
 */
let isRefreshing = false; //刷新
let requests = []
    // 添加请求拦截器
axios.interceptors.request.use(
    config => {
        const requestUrl = config.url;
        // 在发送请求之前做些什么
        if (requestUrl.indexOf('/user/login') != -1 ||
            requestUrl.indexOf('/user/logout') != -1 ||
            requestUrl.indexOf('/user/refresh') != -1) {
            return config;
        }

        if (getToken()) {
            // 获取当前时间，到秒
            const localTime = parseInt(new Date().getTime() / 1000);
            // 获取过期时间
            const ExpireIn = getExpireIn();
            //访问时间小于5分钟刷新
            if (ExpireIn - localTime <= 5 * 60) {
                if (!isRefreshing) {
                    isRefreshing = true
                    store.dispatch('user/refreshToken').then(res => {
                        const data = res.data;
                        isRefreshing = false;
                        requests.forEach(cb => cb(data))
                        requests = []
                    }).catch((res) => {
                        console.error('refresh token error: ', res)
                    })
                }
                const retryOriginalRequest = new Promise((resolve) => {
                    requests.push((data) => {
                        // 因为config中的token是旧的，所以刷新token后要将新token传进来
                        config.headers['Authorization'] = 'Bearer ' + data.jwt_token
                        config.headers['Token'] = data.access_token
                        config.headers['client'] = 'pc'
                        config.headers['businessNo'] = '1'
                        resolve(config)
                    })
                })
                return retryOriginalRequest
            }
        }

        // 设置请求头 Authorization
        const jwt = getJWT()
        if (jwt) {
            config.headers['Authorization'] = 'Bearer ' + jwt
        }
        // 设置请求头 Token
        const token = getToken()
        if (token) {
            config.headers['Token'] = token
        }
        // 放一个标记，是后台还是移动端
        config.headers['client'] = 'pc'
        config.headers['businessNo'] = '1'
        //从cookies中读取出来用户设置的语言，然后传递到后台
        let language = localStorage.getItem("language");
        if(!(language != null && language != "" && language != undefined) ){
          language = 'zh-CN';
        }
        config.headers['language'] = language;
        return config
    },
    error => {
        console.log(error)
        return Promise.reject(error)
    }
)


/**
 * 对请求进行拦截，如果返回401，重新登录
 */
// 响应拦截器
axios.interceptors.response.use(
    response => {
        const {
            data
        } = response
        // 请求失败：兼容不用resultVo包装的返回值
        if (data.code && data.code !== 0) {
            console.log(JSON.stringify(response))
            if (response.data.code == 44444) {
                //令牌刷新失败
                store.dispatch('user/resetToken').then(() => {
                    location.reload()
                })
            } else if (data.code && data.code !== 40011) { // redis中jwt令牌失效
                Message({
                    message: data.message || '系统异常',
                    type: 'error'
                })

                return Promise.reject(data)
            }
        }

        // 成功
        return data
    },
    error => {
        const {
            response
        } = error

        // 401：登录过期
        const userType = store.getters.userType
        if (userType && response && response.status === 401) {
            store.dispatch('user/resetToken').then(() => {
                location.reload()
            })
        } else {
            Message({
                message: error.message,
                type: 'error'
            })
        }

        return Promise.reject(error)
    }
)

export default axios



// WEBPACK FOOTER //
// ./src/common/request.js